import { render } from "./QuestionariManuali.vue?vue&type=template&id=4e4aaad8&scoped=true"
import script from "./QuestionariManuali.vue?vue&type=script&lang=js"
export * from "./QuestionariManuali.vue?vue&type=script&lang=js"

import "./QuestionariManuali.vue?vue&type=style&index=0&id=4e4aaad8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e4aaad8"]])

export default __exports__